/** The opened item above the wall: the preview and focus windows and their controls. */
export default {
  previewRegion: "Preview",
  focusRegion: "Focus",
  moreActions: "More actions",
  maximize: "Maximize",
  restoreSize: "Back to size",
  showLarge: "Show large",
} as const;
